import { useAppStore } from '@/dashboard/store/appStore';
import { usePublicStore } from '@/dashboard/store/publicStore';
import { storeToRefs } from 'pinia';
import { computed, ComputedRef } from 'vue';
import { OwnerAdminCreator } from '@/dashboard/constants/roles';
import { BaseProject, ProjectWithUser } from '@/dashboard/types/project';
import { BaseWorkspace, WorkspaceWithProjects } from '@/dashboard/types/workspace';

export function usePublicMainDraft() {
  const appStore = useAppStore();
  const publicStore = usePublicStore();

  const { project, workspace, workspaces, currentProjectUser, currentWorkspaceUser } = storeToRefs(appStore);
  const { loading, mobileColumns, checkedDrafts, showUploadLimitBanner } = storeToRefs(publicStore);

  const bulkMoveProjects = computed((): ProjectWithUser[] => {
    return (
      workspaces.value?.flatMap((ws) =>
        ws.projects.filter((p) => {
          return p.user && OwnerAdminCreator.includes(p.user.role) && p.id !== project.value?.id;
        })
      ) ?? []
    );
  });

  const groupedBulkMoveProjects: ComputedRef<GroupMoveItems[]> = computed(() => {
    const projectIds = new Set(bulkMoveProjects.value.map((p) => p.id));
    const group = workspaces.value?.map((ws) => {
      const projects = ws.projects.filter((p) => projectIds.has(p.id));
      return {
        workspace: ws,
        projects,
      };
    });

    return group.filter((group) => group.projects.length > 0) ?? [];
  });

  function changeColumnsView() {
    publicStore.changeMobileColumns();
  }

  function selectAll() {
    if (project.value) {
      publicStore.selectAll(project.value.short_link).then();
    }
  }

  function uncheckAll() {
    publicStore.setCheckedDrafts([]);
  }

  return {
    project,
    workspace,
    loading,
    mobileColumns,
    showUploadLimitBanner,
    currentProjectUser,
    currentWorkspaceUser,
    checkedDrafts,
    groupedBulkMoveProjects,
    changeColumnsView,
    selectAll,
    uncheckAll,
    moveSelectedDrafts: publicStore.bulkMoveSelectedDrafts,
    deleteSelectedDrafts: publicStore.deleteSelectedDrafts,
  };
}

export type GroupMoveItems = {
  workspace: BaseWorkspace;
  projects: BaseProject[];
};
